import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'
const title = config.title

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        // 首页
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-home'
          }
        },
        // 软件产品（修复子路由name重复问题）
        {
          path: '/products',
          name: 'products',
          component: resolve => require(['@/view/Products'], resolve),
          meta: {
            title: title + '-Products'
          },
          children: [
            {
              path: '/products',
              redirect: '/products/overview'
            },
            {
              path: '/products/overview',
              name: 'productsOverview', // 修复重复name问题
              component: resolve => require(['@/view/Products_Overview'], resolve),
              meta: {
                title: 'Main Business丨Import And Export'
              }
            },
            {
              path: '/products/importAndExport',
              name: 'productsImportAndExport', // 修复重复name问题
              component: resolve => require(['@/view/Products_ImportAndExport'], resolve),
              meta: {
                title: 'Main Business丨Import And Export'
              }
            },
            {
              path: '/products/numericalControlAndVisionTechnology',
              name: 'productsNumericalControlAndVisionTechnology', // 修复重复name问题
              component: resolve => require(['@/view/Products_NumericalControlAndVisionTechnology'], resolve),
              meta: {
                title: 'Main Business丨Numerical control and vision technology'
              }
            },
            {
              path: '/products/secondHandTextileMachinery',
              name: 'productsSecondHandTextileMachinery', // 修复重复name问题
              component: resolve => require(['@/view/Products_SecondHandTextileMachinery'], resolve),
              meta: {
                title: 'Main Business丨Second-hand textile machinery'
              }
            }, {
              path: '/products/weavingMachine',
              name: 'productsWeavingMachine',
              component: resolve => require(['@/view/Products_WeavingMachine'], resolve),
              meta: {
                title: 'Main Business丨Loom/Weaving machine'
              }
            },
            {
              path: '/products/airCompressor',
              name: 'productsAirCompressor',
              component: resolve => require(['@/view/Products_AirCompressor'], resolve),
              meta: {
                title: 'Main Business丨Air compressor'
              }
            },
            {
              path: '/products/textileAuxiliaryMachine',
              name: 'productsTextileAuxiliaryMachine',
              component: resolve => require(['@/view/Products_TextileAuxiliaryMachine'], resolve),
              meta: {
                title: 'Main Business丨Textile Auxiliary Machine'
              }
            },
            {
              path: '/products/textileSpareParts',
              name: 'productsTextileSpareParts',
              component: resolve => require(['@/view/Products_TextileSpareParts'], resolve),
              meta: {
                title: 'Main Business丨Textile Spare Parts'
              }
            }
          ]
        },
        // 新闻动态列表
        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: title + '-News'
          }
        },
        // 新增：三条不同的新闻详情路由（核心修改）
        {
          path: '/news/detail1/:id', // 带id参数，用于接收新闻ID
          name: 'NewsDetail1',
          component: resolve => require(['@/view/NewsDetail1'], resolve),
          meta: {
            title: title + '-NewsDetail1'
          }
        },
        {
          path: '/news/detail2/:id',
          name: 'NewsDetail2',
          component: resolve => require(['@/view/NewsDetail2'], resolve),
          meta: {
            title: title + '-NewsDetail2'
          }
        },
        {
          path: '/news/detail3/:id',
          name: 'NewsDetail3',
          component: resolve => require(['@/view/NewsDetail3'], resolve),
          meta: {
            title: title + '-NewsDetail3'
          }
        },
        // 公司介绍
        {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: title + '-CompanyIntroduction'
          }
        },
        // 联系我们
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: title + '-ContactUs'
          }
        },
      ]
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js